
import * as XLSX from 'xlsx';
import swal from 'sweetalert2';
import { downloadPDF, downloadVideo } from "../api/fileAPI";

export const getDeviceDetails = async(deviceData) => {

    if(deviceData && (deviceData.isMobile || deviceData.isTablet)){
      return `${deviceData.os} ${deviceData.osVersion}`
    }else{
      return`${deviceData.osName} ${deviceData.osVersion}-${deviceData.browserName}`
    }
};

export const camelCase = (data) =>
  !data || data === ''
    ? ''
    : data
      .replace(/\s+/g, ' ')
      .split(' ')
      .map((d) => capitalizeCamel(d))
      .join(' ');

export const capitalizeCamel = (name) =>
  !name || name === ''
    ? ''
    : `${name[0].toUpperCase()}${name.slice(1).toLowerCase()}`;


export const type = (data) =>
  !data || data === ''
    ? ''
    : data
      .replace(/\s+/g, ' ')
      .split(' ')
      .map((d) => !d || d === '' ? '' : `${d[0].toUpperCase()}${d.slice(1)}`)
      .join(' ');


export const email = (data) =>
  !data || data === ''
    ? ''
    : data
      .replace(/\s+/g, '')
      .toLowerCase()
      .trim();

export const contact = (data) =>
  !data || data === ''
    ? ''
    : data
        .replace(/[^+\d]/g, '')
        .replace(/\+(?=.*\+)/g, '')
        .trim()
        .slice(0, 15);



export const extractExcel = (data) => {

  const readedData    = XLSX.read(data, {type: 'binary'});
  const wsname        = readedData.SheetNames[0];
  const ws            = readedData.Sheets[wsname];
  const dataParse     = XLSX.utils.sheet_to_csv(ws, {header:1});

  return dataParse;

}

export const validateExcel = (value) => {

  let client = {
    ProposalNo  : value[0].trim().replace(/\s+/g, ''),
    Type        : type(value[1].trim()),
    Name        : camelCase(value[2].trim()),
    Age         : Number(value[3].trim()) ? Number(value[3].trim()) : null,
    Email       : value[9].trim(),
    Contact1    : contact(value[4].trim()),
    Contact2    : contact(value[5].trim()),
    TestType    : value[6].trim(),
    Language    : camelCase(value[10].trim()),
    City        : camelCase(value[7].trim()),
    State       : camelCase(value[8].trim()),
    Division    : value[11].trim(),
    BranchCode  : value[12].trim().replace(/\s+/g, ''),
    SumAssured  : value[13].trim(),
    Remark      : value[14].trim()
  }

  const validTypes = ['NB', 'Revival', 'PWB', 'Outstation'];
  const validDO = ['DO-ALIGARH', 'ASANSOL DO', 'AURANGABAD DO', 'BANGLORE DO-II', 'BARDHAMAN DO', 'BELGAUM DO', 'KMDO II', 'CHENNAI DO-I', 'CHENNAI DO-II', 'COIMBATORE DO', 'DEHRADUN DO', 'DHARWAD DO', 'ERNAKULAM DO', 'DO-FAIZABAD', 'DO-GORAKHPUR', 'DO-HALDWANI', 'INDORE DO', 'JABALPUR DO', 'JALPIGURI DO', 'JORHAT DO', 'KARIMNAGAR DO', 'KHARAGHPUR DO', 'KOLHAPUR DO', 'KOTTAYAM DO', 'KOZHI-KODI DO', 'MADURAI DO', 'MUMBAI DO-I', 'MYSORE DO', 'NASHIK DO', 'PUNE DO-II', 'RAICHUR DO', 'RAJKOT DO', 'SALEM DO', 'SATARA DO', 'SHIMOGA DO', 'SILCHAR DO', 'SURAT DO', 'TECH-TERM', 'THANE DO', 'THANJAVUR DO', 'THRISSUR DO', 'TIRUNELVELI DO', 'TRIVANADRUM DO', 'UDUPI DO', 'VADODARA DO', 'VELLORE DO', 'VISAKHAPATNAM DO', 'WARANGAL DO', 'DO-BAREILLY', 'AHMEDABAD DO', 'BANGLORE DO-I', 'KSDO', 'MUMBAI DO-III', 'VARANASI DO', 'LUCKNOW DO', 'KANPUR DO', 'PRYAGRAJ DO', 'ALLAHABAD DO', 'AYODHYA DO', 'RAIPUR DO', 'BILASPUR DO', 'SATNA DO', 'SHAHDOL DO', 'GWALIOR DO', 'BHOPAL DO', 'HYDERABAD DO', 'MACHILIPATNAM DO', 'SECUNDERABAD DO'];

  if (client.ProposalNo == '') {
      return {message: 'Proposal number is missing', client};
  }

  if (client.Type == '') {
      return {message: 'Type is missing', client};
  }

  if (!validTypes.includes(client.Type)) {
    return { message: 'Wrong type', client };
  }

  if (client.Type == '') {
      return {message: 'Type is missing', client};
  }

  if (client.Name == '') {
      return {message: 'Name is missing', client};
  }

  if (client.Contact1 == '') {
      return {message: 'Contact number is missing', client};
  }

  if (client.Division == '') {
      return {message: 'Division is missing', client};
  }

  if (!validDO.includes(client.Division)) {
    return { message: 'Wrong division', client };
  }

  if (client.BranchCode == '') {
      return {message: 'Branch code is missing', client};
  }

  return {message: 'Success', client};

}

export const downloadAndOpenPDFHandler = async (clientId) => {
  try {   
    swal.fire({
      titleText           : 'Loading',
      text                : 'Please Wait...',
      showConfirmButton   : false,
      allowOutsideClick   : false,
      didOpen: () => {
          swal.showLoading();
      }
    });
    const res =  await downloadPDF(clientId);
    if (res) {
      const blob = new Blob([new Uint8Array(res.File.data)], { type: "application/pdf" });
      swal.close();
      const newTab = window.open('', '_blank');
      const url = URL.createObjectURL(blob);
      newTab.location.href = url;
    } 
  } catch (err) {
    swal.close();
    swal.fire({ icon: "error", titleText: "Error!", text: "Failed to generate PDF" });
  }
}

export const downloadVideoHandler = async (clientId) => {
  try {
    swal.fire({
      titleText           : 'Loading Video',
      text                : 'Please Wait...',
      showConfirmButton   : false,
      allowOutsideClick   : false,
      didOpen: () => {
          swal.showLoading();
      }
    });
    const res =  await downloadVideo(clientId);
    if (res) {
      const blob = new Blob([new Uint8Array(res)], { type: "video/mp4" });
      swal.close();
      return blob
    } 
  } catch (err) {
    swal.close();
    swal.fire({ icon: "error", titleText: "Error!", text: "Failed to download video" });
  }
}